export default __webpack_public_path__ + "static/media/wordpress.11ed0915.png";